import GenericPopup from "@/shared-components/popups/components/GenericPopup";

import ImageCropper from "./ImageCropper";

import "./styles/PopupCropTemplateImage.css";

const PopupCropTemplateImage = ({ open,image,selectTemplate,measures,exitCrop,continueCrop,setCroppedFile,setCroppedUrl }) => {
  return (
    <GenericPopup
      open={open}
      className="artwork-options__download-template-templates-selectImg"
    >
      <div className="artwork-options__download-template_header-scale-img">
        <p className="artwork-options__download-template_header-text">
            Generate template
        </p>
        <p className="artwork-options__download-template_header-step-text">
          <span className="artwork-options__download-template_header-step-text-span">
              2.{" "}
          </span>
            Move and scale the artwork
        </p>
      </div>
      <ImageCropper
        source={image}
        width={selectTemplate && measures[selectTemplate].width}
        height={selectTemplate && measures[selectTemplate].height}
        exitCrop={exitCrop}
        continueCrop={continueCrop}
        setCroppedUrl={setCroppedUrl}
        setCroppedFile={setCroppedFile}
      />
    </GenericPopup>
  );
};

export default PopupCropTemplateImage;
